webpackJsonp([35783957827783],{

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _aboutTheAuthorModule = __webpack_require__(532);
	
	var _aboutTheAuthorModule2 = _interopRequireDefault(_aboutTheAuthorModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutTheAuthor = function AboutTheAuthor() {
	  return _react2.default.createElement(
	    'div',
	    { className: _aboutTheAuthorModule2.default.container },
	    _react2.default.createElement(
	      'h3',
	      { className: _aboutTheAuthorModule2.default.header },
	      'About The Author'
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: _aboutTheAuthorModule2.default.imageWrapper },
	        _react2.default.createElement('img', {
	          className: _aboutTheAuthorModule2.default.image,
	          src: 'https://pp.userapi.com/c628027/v628027303/2f8f2/Lj9uA2PnXPQ.jpg'
	        })
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: _aboutTheAuthorModule2.default.textBlock },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Hey, I\u2019m Maksim Ivanov and I help frontend developers take their coding skills and productivity to the next level.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'I work as software engineer for more than 8 years. I\u2019ve been developing websites, online games and web applications \u2014 and I\u2019d love to help you become a more proficient frontend developer.'
	        )
	      )
	    )
	  );
	};
	
	exports.default = AboutTheAuthor;
	module.exports = exports['default'];

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var containerStyle = {
	  paddingTop: 80,
	  paddingBottom: 80,
	  maxWidth: 800,
	  margin: 'auto'
	};
	
	var headerStyle = {
	  textAlign: 'center',
	  marginBottom: 40
	};
	
	var AboutTheCourse = function AboutTheCourse() {
	  return _react2.default.createElement(
	    'div',
	    { style: containerStyle },
	    _react2.default.createElement(
	      'h3',
	      { style: headerStyle },
	      'What You\'ll Learn'
	    ),
	    _react2.default.createElement(
	      'section',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'This course covers all the ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'essential topics'
	        ),
	        ' reqruired to build modern javascript applications using ReactJS.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'First you will learn the fundamentals and the ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'core idea'
	        ),
	        ' ',
	        'behind the ReactJS framework. You will learn to think in ReactJS terms.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Then you\'ll go through all the moving parts you\'ll need to build your application and ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'within minutes'
	        ),
	        ' you\u2019ll grasp Components, JSX, State, Props, Events and Forms along with best practices to build real apps.'
	      )
	    )
	  );
	};
	
	exports.default = AboutTheCourse;
	module.exports = exports['default'];

/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _footerStyle;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var footerStyle = (_footerStyle = {
	  background: 'rgb(48,38,83)'
	}, _footerStyle['background'] = 'linear-gradient(63deg, rgba(48,38,83,1) 0%, rgba(62,38,119,1) 68%, rgba(74,33,148,1) 100%)', _footerStyle.height = 100, _footerStyle.width = '100%', _footerStyle.position = 'absolute', _footerStyle.bottom = 0, _footerStyle);
	
	var Footer = function Footer() {
	  return _react2.default.createElement('div', { style: footerStyle });
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _headerStyle, _linkStyle;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(46);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var headerStyle = (_headerStyle = {
	  background: 'rgb(48,38,83)'
	}, _headerStyle['background'] = 'linear-gradient(63deg, rgba(48,38,83,1) 0%, rgba(62,38,119,1) 68%, rgba(74,33,148,1) 100%)', _headerStyle.paddingTop = 65, _headerStyle.paddingBottom = 85, _headerStyle.paddingLeft = 15, _headerStyle.paddingRight = 15, _headerStyle.fontFamily = 'Open Sans', _headerStyle.fontSize = 60, _headerStyle.fontWeight = 'extra-bold', _headerStyle.color = '#FFFFFF', _headerStyle);
	
	var h1style = {
	  textAlign: 'center',
	  lineHeight: 1.5
	};
	
	var h2style = {
	  textAlign: 'center',
	  lineHeight: 1.5,
	  marginBottom: 75
	};
	
	var linkStyle = (_linkStyle = {
	  fontSize: 25,
	  background: 'rgb(233,167,0)'
	}, _linkStyle['background'] = 'linear-gradient(30deg, rgba(233,167,0,1) 0%, rgba(222,54,47,1) 100%)', _linkStyle.color = '#fff', _linkStyle.textDecoration = 'none', _linkStyle.padding = 20, _linkStyle.display = 'block', _linkStyle.maxWidth = 350, _linkStyle.margin = 'auto', _linkStyle.marginBottom = 75, _linkStyle.lineHeight = 1.5, _linkStyle.textAlign = 'center', _linkStyle.borderRadius = 6, _linkStyle.boxShadow = '0 0 0 1px rgba(16,22,26,.1),0 4px 8px rgba(16,22,26,.2),0 18px 46px 6px rgba(16,22,26,.2)', _linkStyle.textTransform = 'uppercase', _linkStyle.fontFamily = 'Open Sans', _linkStyle);
	
	var mottoStyle = {
	  fontSize: 26,
	  maxWidth: 800,
	  textAlign: 'center',
	  margin: 'auto',
	  lineHeight: 1.6,
	  letterSpacing: 0.4
	};
	
	var Header = function Header() {
	  return _react2.default.createElement(
	    'div',
	    { style: headerStyle },
	    _react2.default.createElement(
	      'h1',
	      { style: h1style },
	      'Basic React'
	    ),
	    _react2.default.createElement(
	      'h2',
	      { style: h2style },
	      'Learn ReactJS in just a couple of days.'
	    ),
	    _react2.default.createElement(
	      'a',
	      { style: linkStyle, href: '/signup' },
	      'Enroll for free'
	    ),
	    _react2.default.createElement(
	      'p',
	      { style: mottoStyle },
	      'Start building real ReactJS apps. Jump in with best practices, solid understanding and confidence.'
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 532:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-LandingPage-components----about-the-author-module---container---dsB1V","header":"src-components-LandingPage-components----about-the-author-module---header---2CO-A","imageWrapper":"src-components-LandingPage-components----about-the-author-module---imageWrapper---1j3fG","image":"src-components-LandingPage-components----about-the-author-module---image---1KMv_","textBlock":"src-components-LandingPage-components----about-the-author-module---textBlock---2APNE"};

/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Header = __webpack_require__(418);
	
	Object.defineProperty(exports, 'Header', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Header).default;
	  }
	});
	
	var _AboutTheCourse = __webpack_require__(416);
	
	Object.defineProperty(exports, 'AboutTheCourse', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AboutTheCourse).default;
	  }
	});
	
	var _AboutTheAuthor = __webpack_require__(415);
	
	Object.defineProperty(exports, 'AboutTheAuthor', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AboutTheAuthor).default;
	  }
	});
	
	var _Footer = __webpack_require__(417);
	
	Object.defineProperty(exports, 'Footer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Footer).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(46);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _components = __webpack_require__(419);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LandingPage = function LandingPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_components.Header, null),
	    _react2.default.createElement(
	      'div',
	      { style: { padding: '0 15px' } },
	      _react2.default.createElement(_components.AboutTheCourse, null),
	      _react2.default.createElement(_components.AboutTheAuthor, null)
	    )
	  );
	};
	
	exports.default = LandingPage;
	module.exports = exports['default'];

/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LandingPage = __webpack_require__(420);
	
	var _LandingPage2 = _interopRequireDefault(_LandingPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(_LandingPage2.default, null);
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-11d77219dd1c4ac28d63.js